/**
* Header Navigation Primary
*/
function fnNavigationPrimary( i, oSection ) {

	var oSection 				= $( oSection ),
		oOverlay 				= $( '.base-overlay' );

	/**************
	* Desktop navigation
	**************/
	function fnDesktopNavigation() {

		var oSubMenu 			= $( 'nav.desktop .sub-menu-wrap', oSection );

		oSubMenu.hover( function() {

			var oParentItem 	= $( this ).parent( 'li.menu-item-has-children' ),
				oParentAnchor 	= $( '> a', oParentItem );

			oParentAnchor.toggleClass( 'hover' );

		});

	}
	fnDesktopNavigation();


	/**************
	* Mobile navigation
	**************/

	/**
	* Open/close
	*/
	function fnMobileNavOpenClose() {

		var oMenu 				= $( 'nav.mobile', oSection ),
			oOpenButton 		= $( '.menu-button--open', oSection ),
			oCloseButton 		= $( '.menu-button--close', oSection );

		// Open menu
		oOpenButton.click( function() {
			oMenu.addClass( 'display' );
			oOverlay.addClass( 'display' );
		});

		// Close menu
		oCloseButton.click( function() {
			oMenu.removeClass( 'display' );
			oOverlay.removeClass( 'display' );
		});

		oOverlay.click( function() {
			oMenu.removeClass( 'display' );
			oOverlay.removeClass( 'display' );
		});

	}
	fnMobileNavOpenClose();


	/**
	* Sub-menu
	*/
	function fnMobileNavMenu(){

		var oMobileSlider 		= $( 'nav.mobile .menu' ),
			oBackButton			= $( '.menu-button--back' );

		if ( oMobileSlider.length <= 0 ) return;

		// Expand sub-menus
		oMobileSlider.find( 'li.menu-slide.first-slide a.has-children' ).on( "click", function(e) {
			var iChildren = $(this).data('id'),
				oTargetSlide = oMobileSlider.find("li.menu-slide[data-parent='"+iChildren+"']");
			e.preventDefault();
			oMobileSlider.find("li.menu-slide").removeClass("current");
			oTargetSlide.addClass("current");
			oMobileSlider.addClass('menu-child-open');
			oBackButton.addClass('reveal');
		});

		// Back button (return to top-level list)
		oBackButton.on( "click", function(e) {
			oMobileSlider.find("li.menu-slide").removeClass("current");
			oMobileSlider.find("li.menu-slide.first-slide").addClass("current");
			oMobileSlider.removeClass('menu-child-open');
			oBackButton.removeClass('reveal');
		});

	}
	fnMobileNavMenu();


}
